import Vue from 'vue';
import Vuex from 'vuex';
import Firebase from 'firebase';
import db from '../main.js'

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    user: null,
    isAdmin: false,
    company: null
  },
  getters: {
    getUser: state => {
      return state.user;
    },
    getAdmin: state => {
      return state.isAdmin;
    },
    getCompany: state => {
      return state.company;
    }
  },
  mutations: {
    setUser: state => {
      if (Firebase.auth().currentUser) {
        state.user = Firebase.auth().currentUser;
        console.log(state.user)
        db.collection('users').where('id', '==', state.user.uid).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            state.isAdmin = doc.data().isAdmin;
            state.company = doc.data().company;
          })
        })
      } else {
        state.user = null,
        state.isAdmin = false,
        state.company = null
      }
    },
    setTribeUser: state => {
      if (Firebase.auth().currentUser) {
        state.user = Firebase.auth().currentUser;
        state.isAdmin = true;
        state.company = 'Fiction Tribe';
      } else {
        state.user = null,
        state.isAdmin = false,
        state.company = null
      }
    },
  },
  actions: {
    setUser: context => {
      context.commit('setUser');
    },
    setTribeUser: context => {
      context.commit('setTribeUser');
    }
  }
});
